define('model/organization.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var OrganizationModel = BaseModel.extend({
    radioRequests: {
      'models OrganizationModel': '@constructor',
    },

    urlRoot: '/api/v2/organization',
  });

  module.exports = OrganizationModel;
});

